import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useTranslation } from "react-i18next";
import AutocompleteInput from "../../../common/forms/AutocompleteInput";
import { genStatusText } from "../../../utils/GeneralUtils";
import { PageVisibility } from "../../../utils/PageVisibility";
import styles from "../management.module.scss";

type Props = {
  index: number;
  target: string;
  name: string;
  id: string;
  featuredItem: { id: string; name: string; status: string };
  options: Array<string>;
  handleChange: (index: number, value: string) => boolean;
  removeItem: (index: number) => void;
};
const FeaturedSettingsItem: React.FC<Props> = ({
  index,
  target,
  name,
  id,
  featuredItem,
  options,
  handleChange,
  removeItem,
}) => {
  const { t } = useTranslation();

  const status_class =
    featuredItem.status === PageVisibility.AwaitingInspection
      ? styles["pending"]
      : featuredItem.status === PageVisibility.PubliclyVisible
      ? styles["open"]
      : "";

  return (
    <li className={styles["c-management__input-list"]}>
      <div className={styles["c-management__input-item"]}>
        <AutocompleteInput
          label={target}
          name={`featured-${name}`}
          id={`featured${id}`}
          inputClass={"c-management__input-text"}
          placeholder={`${target}を入力または選択`}
          value={featuredItem.name}
          options={options}
          handler={(val) => {
            return handleChange(index, val);
          }}
        />
      </div>
      <button
        type="button"
        className={styles["c-management__delete-btn"]}
        onClick={() => removeItem(index)}
      >
        <FontAwesomeIcon icon={["fal", "trash-alt"]} />
        {t("削除")}
      </button>
      <span className={`${styles["c-management__status"]} ${status_class}`}>
        {genStatusText(featuredItem.status)}
      </span>
    </li>
  );
};

export default FeaturedSettingsItem;
